import { GraphEdge } from '../GraphEdge'

export function generateAutofillEdges(templateField) {
  const autofill = getAutofillGovernance(templateField)
  const fieldId = templateField.field_id
  const results = []

  if (autofill && autofill.field_id) {
    // from, to.
    results.push(new GraphEdge(autofill.field_id, fieldId))
  }

  return results
}

/**
 * Gets the autoofill for the template_field dependending on where
 * it's supposed to come from (variable or not)
 *
 * @param templateField
 * @returns
 */
function getAutofillGovernance(templateField) {
  const gov = templateField.field.segment_type === 'variable' ? templateField : templateField.field

  return gov.autofill
}
